import { Component, HostBinding } from "@angular/core";

@Component({
    selector: "sps-focused-task-actions",
    template: `
        <div class="sps-list-action-bar">
            <div class="sps-list-action-bar__actions">
                <ng-content></ng-content>
            </div>
        </div>
    `,
})
export class SpsFocusedTaskActionsComponent {
    static readonly displayName = "sps-focused-task-actions";
    static readonly props = {};

    @HostBinding("class.sps-list-action-bar-container")
    @HostBinding("class.z-stratum-bar")
    readonly _hostClasses = true;
}
